module.exports = __webpack_public_path__ + "static/media/logo.bf4f8ea1.png";